import React from 'react';
import { AnimatePresence } from 'framer-motion';

import { Wrapper, Icon, Text, Time, Inside } from './styles';
import { useFormattedMsToTime, useGameStateContent, useGetGameState } from '@/hooks';
import { Competition } from '@/client/common/structs';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(relativeTime);

interface GameTimerProps {
    providedGame?: Competition;
    compact?: boolean;
}

const transition = {
    ease: 'easeIn',
    duration: 0.4,
};
export const GameTimer = ({ providedGame, compact }: GameTimerProps) => {
    const now = dayjs.utc();
    const { gameState } = useGetGameState(providedGame);
    const { gameStateText, gameTime } = useGameStateContent(providedGame);
    const timeLeft = useFormattedMsToTime(gameTime);
    const timerKey = providedGame?.slug;
    const pastTime = now.isAfter(dayjs.utc(gameTime)) || gameState === 'ended';
    const countdownTime = pastTime ? dayjs.utc(gameTime).fromNow() : timeLeft;
    const hideTimer = !countdownTime || countdownTime == '00m 00s';

    return (
        <AnimatePresence mode="wait">
            {!hideTimer ? (
                <div key={`${timerKey}-${gameState}-${gameTime}`}>
                    <Wrapper
                        transition={transition}
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        $gameState={gameState}
                        $compact={compact}
                    >
                        <Inside $gameState={gameState} $compact={compact}>
                            <Icon emojiID={gameState === 'ended' ? '🔒' : '⏰'} />
                            <Text>{gameStateText} </Text>
                            <Time>{countdownTime}</Time>
                        </Inside>
                    </Wrapper>
                </div>
            ) : null}
        </AnimatePresence>
    );
};
